import React from 'react';
import { useHistory } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Classroom } from 'types/schema-generated-types';
import ClassroomCard from '../Cards/ClassroomCard';
import LazyLoadingList from '../ListUtilities/LazyLoadingList';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(3) },
  classroomContainer: {
    display: 'grid',
    gridGap: 12,
    gridTemplateColumns: `repeat(auto-fill, minmax(325px, 1fr))`,
    gridAutoFlow: 'dense'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  classroomCard: {
    boxSizing: 'border-box',
    height: '100%'
  }
}));

interface UserClassInformationProps {
  classrooms?: Array<Classroom>;
  emptyMessage?: string;
  btnText: string;
}

const UserClassesInformation: React.FC<UserClassInformationProps> = ({
  classrooms,
  emptyMessage,
  btnText
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div>
      <div className={classes.titleContainer}>
        <Typography variant="h2" className={classes.title}>
          My Classes
        </Typography>
        <Button
          onClick={(): void => history.push('/classrooms')}
          variant="outlined"
          size="small"
          disableElevation
          startIcon={<ArrowForwardIcon />}
        >
          {btnText}
        </Button>
      </div>
      <Paper className={classes.root} elevation={3}>
        <div className={classes.classroomContainer}>
          {!classrooms?.length && <Typography>{emptyMessage}</Typography>}
          <LazyLoadingList
            data={classrooms}
            limit={50}
            renderItem={({ index, item }) => (
              <ClassroomCard
                key={item.id}
                classroom={item}
                onClick={(): void => {
                  history.push(`/classrooms/${item.id}`);
                }}
                className={classes.classroomCard}
              />
            )}
          />
        </div>
      </Paper>
    </div>
  );
};

export default UserClassesInformation;
